import { UI } from "@wwimmo/ui";
import { useContext, useCallback } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";
import { SelectComponent } from "src/api/Select";
import { Route, selectRoute } from "src/config/routes";
import { RootStoreContext } from "src/stores/RootStore";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { getLang } from "src/utils/i18n";

interface SelectOtherProps {
    component: SelectComponent;
}

export const SelectOther = (props: SelectOtherProps) => {
    const { t } = useTranslation();

    const other_schema = yup.object().shape({
        other: yup.string().required(t("form.required_field"))
    });

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm<{ other: string }>({ resolver: yupResolver(other_schema) });
    const { component } = props;
    const { easyContactStore, uiStore } = useContext(RootStoreContext);
    const { processId } = useParams<{ processId: string; stepId: string }>();
    const history = useHistory();
    const { nextStep } = easyContactStore.stepNavigation;

    const onSubmit: SubmitHandler<{ other: string }> = useCallback(
        (data) => {
            easyContactStore.setComponent(component.id, data.other);
            if (nextStep) {
                history.push(
                    selectRoute(Route.step, { processId, stepType: String(nextStep.type), stepId: nextStep.id })
                );
            }
        },
        [history, easyContactStore, nextStep, processId, component]
    );

    return (
        <UI.Container className="pt-4">
            <UI.Row>
                <UI.Col md={uiStore.defaultColumnSize.md}>
                    <UI.Form onSubmit={handleSubmit(onSubmit)}>
                        <UI.Input
                            {...register("other", { required: true })}
                            defaultValue={easyContactStore.notification.component || ""}
                            label={`${
                                component.component_mls.find((component) => component.language === getLang())?.hint ||
                                t("screens.damage.description")
                            } *`}
                            name="other"
                            type="text"
                            errorMsg={errors.other ? errors.other.message : undefined}
                        />
                        <UI.Button onClick={handleSubmit(onSubmit)} label={t("labels.continue")} />
                    </UI.Form>
                </UI.Col>
            </UI.Row>
        </UI.Container>
    );
};
